import { ITenantCountryItemRaw, ITenantCountryItem } from '../types';

export const formatTenantCountryList = (
  countryList: ITenantCountryItemRaw[]
): ITenantCountryItem[] => {
  const formattedCountryList: ITenantCountryItem[] = countryList.map(
    (country) => {
      const {
        _id,
        ISOCode,
        countryCode,
        currencyCode,
        flag,
        name,
        telephonePrefix,
        tenantId,
      } = country;
      return {
        ISOCode,
        countryCode,
        currencyCode,
        flag,
        id: _id,
        label: name,
        name,
        count: telephonePrefix,
        tenantId,
        telephonePrefix,
      };
    }
  );

  return formattedCountryList;
};
